import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import SongCard from '../components/SongCard';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function Library() {
  const { t, lang, library, liked, feed } = useApp();
  const [tab, setTab] = useState('songs');

  const likedSongs = [...library, ...feed].filter(s => liked.includes(s.id));

  return (
    <div className="px-4 lg:px-8 py-6 fade-up">
      <div className="flex items-end justify-between mb-6">
        <h1 className="font-display text-3xl md:text-4xl font-extrabold">{t('library.title')}</h1>
        <Link to="/create"><Button className="bg-white text-black hover:bg-zinc-200 gap-2"><Sparkles size={16}/> {t('nav.create')}</Button></Link>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-[#16161a] border border-white/5">
          <TabsTrigger value="songs">{t('library.songs')} ({library.length})</TabsTrigger>
          <TabsTrigger value="liked">{t('library.liked')} ({likedSongs.length})</TabsTrigger>
          <TabsTrigger value="playlists">{t('library.playlists')}</TabsTrigger>
        </TabsList>

        <TabsContent value="songs" className="mt-6">
          {library.length === 0 ? (
            <div className="text-sm text-zinc-500 py-16 text-center border border-dashed border-white/10 rounded-2xl">
              {t('library.empty')}
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-4">
              {library.map(s => <SongCard key={s.id} song={s} list={library} />)}
            </div>
          )}
        </TabsContent>

        <TabsContent value="liked" className="mt-6">
          {likedSongs.length === 0 ? (
            <div className="text-sm text-zinc-500 py-16 text-center border border-dashed border-white/10 rounded-2xl">
              {lang==='fr'?'Aucun titre aimé pour le moment':'No liked tracks yet'}
            </div>
          ) : (
            <div className="space-y-1">
              {likedSongs.map(s => <SongCard key={s.id} song={s} list={likedSongs} layout="row" />)}
            </div>
          )}
        </TabsContent>

        <TabsContent value="playlists" className="mt-6">
          <div className="text-sm text-zinc-500 py-16 text-center border border-dashed border-white/10 rounded-2xl">
            {lang==='fr'?'Bientôt : crée tes propres playlists':'Soon: create your own playlists'}
          </div>
        </TabsContent>
      </Tabs>
      <div className="h-32" />
    </div>
  );
}
